<div *ngIf="this.global.IsLoggedIn =='true'" style="padding-top:50px">
  <iframe width="100%" height="700" [src]="PlannerDAVPURL | safe" frameborder="0" allowFullScreen="true"></iframe>
</div>
